'use client';
import clsx from 'clsx';
import { useState } from 'react';

export enum HomeAwayEventsTypes {
  ALL = 'All games',
  HOME = 'Home',
  AWAY = 'Away',
}

interface Props {
  onTabChange: (tab: HomeAwayEventsTypes) => void;
}

export const HomeAwayEventsTab = ({ onTabChange }: Props) => {
  const [activeTab, setActiveTab] = useState(HomeAwayEventsTypes.ALL);
  const buttonItemClassname = (isActive: boolean) =>
    clsx('text-gray-600 font-semibold px-3 h-10 rounded-lg', {
      'bg-gray-800 text-white': isActive,
    });

  const onTabClick = (tab: HomeAwayEventsTypes) => {
    setActiveTab(tab);
    onTabChange(tab);
  };

  return (
    <div>
      <div className="hidden gap-x-2 rounded-lg border border-gray-200 p-1 md:flex">
        <button
          onClick={() => onTabClick(HomeAwayEventsTypes.ALL)}
          className={buttonItemClassname(activeTab === HomeAwayEventsTypes.ALL)}
        >
          {HomeAwayEventsTypes.ALL}
        </button>
        <button
          onClick={() => onTabClick(HomeAwayEventsTypes.HOME)}
          className={buttonItemClassname(
            activeTab === HomeAwayEventsTypes.HOME
          )}
        >
          {HomeAwayEventsTypes.HOME}
        </button>
        <button
          onClick={() => onTabClick(HomeAwayEventsTypes.AWAY)}
          className={buttonItemClassname(
            activeTab === HomeAwayEventsTypes.AWAY
          )}
        >
          {HomeAwayEventsTypes.AWAY}
        </button>
      </div>
    </div>
  );
};
